import "./App.css";
import Header from "./Header";
import React, { useEffect } from "react";
import Home from "./Home";
import Checkout from "./Checkout";
import SignIn from "./SignIn";
import { auth } from "./firebase.js";
import { useStateValue } from "./StateProvider";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
function App() {
  const [{ basket, user }, dispatch] = useStateValue();
  useEffect(() => {
    auth.onAuthStateChanged((auser) => {
      if (auser) {
        dispatch({ type: "SET_USER", user: auser });
      } else {
        dispatch({ type: "SET_USER", user: null });
      }
    });
  }, []);
  return (
    <Router>
      <div className="App">
        <Switch>
          <Route path="/signin">
            <SignIn></SignIn>
          </Route>

          <Route path="/checkout">
            <Header />
            <Checkout></Checkout>
          </Route>
          <Route path="/">
            <Header />
            <Home />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
